export const DAO_CODE = 'EXPENSE' + 'REPORT' + '_DAO';
